/**
 * Counts the total number of array attribute values in an object
 * @param obj - The object to count array values from
 * @returns The total count of array values
 */
export const countArrayAttributeValues = (obj?: object) =>
  obj
    ? Object.values(obj).reduce(
        (count, attribute) => count + (attribute?.length || 0),
        0
      )
    : 0;

/**
 * Filters out permanent keys from an object
 * @param obj - The object to filter
 * @param permanentKeys - Array of keys to exclude from the result
 * @returns The filtered object without permanent keys
 */
export const filterByPermanentKeys = (obj?: object, permanentKeys = []) =>
  obj
    ? Object.entries(obj)
        ?.filter(([name]) => !permanentKeys?.find((value) => value === name))
        .reduce((accumulator, [name, value]) => {
          return { ...accumulator, [name]: value };
        }, {})
    : undefined;
